<template>
<div class="extra">
    <el-table border lazy  row-key="id" height="40" :load="load" :data="tableData" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="scoreAttributeText" label="评分属性" width="110"></el-table-column>
        <el-table-column prop="scoreItem" label="评分项" width="200"></el-table-column>
        <el-table-column prop="scoreStandard" label="评分标准" width="350" show-overflow-tooltip></el-table-column>
        <el-table-column prop="scoreScale" label="权重（%）" width="100"></el-table-column>
        <el-table-column prop="supplierName" label="供应商" width="200"></el-table-column>
        <el-table-column v-for="(item,index) in columns" :key="index" :prop="item.userCode" :label="'评分人：'+item.userName" width="200"></el-table-column>
        <el-table-column prop="avgScore" label="平均得分"></el-table-column>
    </el-table>
</div>
</template>
<script>
import { resultHead, resultParent, resultChildren } from '../../../../lsrm/api/gradeResult.js';
import { dictWithUrl } from '@/components/lots/api';
export default {
    data() {
        return {
            columns: [],
            tableData: [],
            dictData: {}
        };
    },
    mounted() {
        // 数字字典转换
        dictWithUrl('BID_SCORING_ATTRIBUTE').then(res => {
            this.dictData = res.data;
            this.init();
        });
    },
    methods: {
        async init() {
            const res = await resultHead({ bidNo: this.$route.query.bidNo, userType: 50 });
            if (res && +res.code === 0) {
                this.columns = res.data;
                const parentRes = await resultParent({ bidNo: this.$route.query.bidNo, scoreAttribute: 4 });
                if (parentRes && +parentRes.code === 0) {
                    this.tableData = parentRes.data;
                    this.conversionData(this.tableData);
                    this.tableData.forEach(item => {
                        this.$set(item, 'hasChildren', true);
                    });
                }
            }
        },

        async load(tree, treeNode, resolve) {
            const res = await resultChildren({ bidNo: this.$route.query.bidNo, scoreAttribute: 4, supplierCode: tree.supplierCode });
            if (res && +res.code === 0) {
                this.conversionData(res.data);
                resolve(res.data);
            }
        },
        conversionData(list) {
            list.forEach(item => {
                item.scoreAttributeText = this.dictData.BID_SCORING_ATTRIBUTE[item.scoreAttribute];
            });
        }
    }

};
</script>
<style lang="less">
.extra{
     .el-table {
        min-height: calc(~ '100vh - 310px');
        max-height: calc(~ '100vh - 310px');
        .cell{display: flex;align-items: center}
    }
    .el-table--border{ border: 1px solid #ebeef5;}
}
</style>